import { createFileRoute } from "@tanstack/react-router";

import { parseAreasSearch } from "@/features/catalog";
import { AreasPage } from "@/features/catalog/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/catalog/areas")({
  validateSearch: strictSearch(parseAreasSearch),
  component: Areas,
});

function Areas() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <AreasPage search={search} onSearchChange={(next) => void navigate({ search: next })} />;
}
